<template>
  <div class="flex flex-col gap-6 w-full mx-auto p-6 bg-gray-50">
    
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
      <div class="bg-white rounded-xl shadow-sm"><DailySalesTotalCard /></div>
      <div class="bg-white rounded-xl shadow-sm"><WeeklySalesTotalCard /></div>
      <div class="bg-white rounded-xl shadow-sm"><AvgSpendTotalCard  /></div>
      <div class="bg-white rounded-xl shadow-sm"><AvgCostTotalCard /></div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
      
      <div class="bg-white p-4 rounded-xl shadow-sm w-full">
        <TopCustomer />
      </div>
      
      <div class="bg-white p-4 rounded-xl shadow-sm w-full">
        <WeeklySales />
      </div>
      
      <div class="bg-white p-4 rounded-xl shadow-sm w-full">
        <TopProduct />
      </div>
      
      <div class="bg-white p-4 rounded-xl shadow-sm w-full">
        <MonthlySales />
      </div>

    </div>

  </div>
</template>

<script>
import TopCustomer from './TopCustomer.vue';
import TopProduct from './TopSaelsProducts.vue';
import WeeklySales from './WeeklyChart.vue'
import MonthlySales from './MonthlyChart.vue';
import DailySalesTotalCard from './card/DailySalesTotalCard.vue';
import WeeklySalesTotalCard from './card/WeeklySalesTotalCard.vue';
import AvgSpendTotalCard from './card/AvgSpendTotalCard.vue';
import AvgCostTotalCard from './card/AvgCostTotalCard.vue';
export default {
  // 必須在這裡註冊組件
  name: 'ChartIndex',
  components: {
    TopCustomer,
    TopProduct,
    WeeklySales,
    MonthlySales,
    DailySalesTotalCard,
    WeeklySalesTotalCard,
    AvgSpendTotalCard,
    AvgCostTotalCard
  }
}

</script>